import {
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { useSnackbar } from "notistack";
import { useState } from "react";
import "../../../../Tooltip/styles/tooltip.css";
import { useCreateFolder } from "../FileQueries/createProjectFolder";
import "./styles/create-folder-popover.css";

// Create a new folder popover
const CreateFolderPopover = ({
  open,
  setOpen,
  projectId,
  queryClient,
  userType,
}) => {
  const [newFolderState, setNewFolderState] = useState({
    name: "",
    displayName: "",
  });
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const createFolder = useCreateFolder(
    queryClient,
    projectId,
    userType,
    enqueueSnackbar,
    setOpen,
  );

  const handleClose = () => {
    setNewFolderState({
      name: "",
      displayName: "",
    });
    setOpen(false);
  };

  const convertToCamelCase = (str) => {
    // Should convert "New Folder Name" to "newFolderName" and Noi to noi
    return str
      .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special characters except spaces
      .split(" ")
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      .join("");
  };

  return (
    <Modal id="create-folder-modal" open={open} onClose={handleClose}>
      <div id="create-folder-form">
        <Backdrop id="create-folder-backdrop" open={openBackdrop}>
          CREATING FOLDER DO NOT LEAVE THIS PAGE
          <CircularProgress id="create-folder-progress" />
        </Backdrop>
        <h1 id="create-folder-heading">Create New Folder</h1>
        <FormControl
          id="folder-form-control"
          className="folder-form-control"
          variant="outlined"
          classes={{
            root: "folder-form-root",
          }}
        >
          <InputLabel
            id="folder-field-label"
            classes={{
              shrink: "input-folder-label-shrink",
            }}
            htmlFor="folder-name-input"
          >
            Folder Name
          </InputLabel>
          <OutlinedInput
            type="text"
            id="folder-text"
            value={newFolderState.displayName}
            onChange={(e) =>
              setNewFolderState({
                ...newFolderState,
                displayName: e.target.value,
                name: convertToCamelCase(e.target.value),
              })
            }
            label="Folder Name"
            classes={{
              root: "input-folder-root",
              notchedOutline: "input-folder-notched-outline",
              input: "input-folder-input",
            }}
            autoComplete="off"
          />
        </FormControl>
        <div id="create-folder-btns-container">
          <Button
            id="create-folder-cancel-btn"
            className="create-folder-btn"
            variant="contained"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            id="create-folder-create-btn"
            className="create-folder-btn"
            variant="contained"
            onClick={async () => {
              setOpenBackdrop(true);
              await createFolder.mutateAsync({
                projectId,
                name: newFolderState.name,
                displayName: newFolderState.displayName,
              });
              setOpenBackdrop(false);
            }}
          >
            Create
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateFolderPopover;
